import { render } from "./Uploader.vue?vue&type=template&id=e9289422"
import script from "./Uploader.vue?vue&type=script&lang=js"
export * from "./Uploader.vue?vue&type=script&lang=js"

import "./Uploader.vue?vue&type=style&index=0&id=e9289422&lang=css"

import exportComponent from "C:\\Users\\Dell Precision 7730\\Desktop\\git\\Zentify\\Zentify_escuela_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__